export default "__VITE_ASSET__BN5OdfcE__"